// extracted by mini-css-extract-plugin
export default {"wrapper":"gp","form":"hp","circle":"ip","success":"jp","button":"kp"};